// extracted by mini-css-extract-plugin
export default {"colorTextLabel":"H3-z","colorTextValue":"I3-z","swatches":"J3-z","collapseLink":"K3-z","isCollapsed":"L3-z","dropdown":"M3-z","disabled":"N3-z"};